// eslint-disable-next-line no-restricted-imports
import { Link as MuiLink, LinkProps, ButtonProps, Button } from "@mui/material";
import _ from "lodash";
import React from "react";
import { ReactElement } from "react";
import {
  // eslint-disable-next-line no-restricted-imports
  Link as RouterLink,
  LinkProps as RouterLinkProps,
} from "react-router-dom";

export const InternalLink = React.forwardRef<any, RouterLinkProps & LinkProps>(
  (props, ref) => <MuiLink {...props} ref={ref} component={RouterLink} />
);

export const ExternalLink = (
  props: Exclude<LinkProps, "to"> & { href: string }
): ReactElement => {
  return <MuiLink target="_blank" rel="noopener noreferrer" {...props} />;
};

export const LinkButton = (props: Exclude<LinkProps, "to">): ReactElement => {
  return <MuiLink {...props} sx={{ ...props.sx, cursor: "pointer" }} />;
};

export const ButtonLink = (
  props: { to: string } & ButtonProps
): ReactElement => {
  return <Button {...props} LinkComponent={RouterLink} />;
};
